import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { register } from "../../../services/oprations/authAPI";
import toast from "react-hot-toast";

const AddUserForm = () => {
  const { darkMode } = useOutletContext();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form, setForm] = useState({
    name: "",
    email: "",
    role: "",
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validatePassword = (password) => {
    const isValidLength = password.length >= 12;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    return (
      isValidLength &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSpecialChar
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validatePassword(form.password)) {
      toast.error(
        "Password must be at least 12 characters long and include lowercase, uppercase, number, and special character"
      );
      return;
    }

    dispatch(
      register(
        form.role,
        form.name,
        form.email,
        form.password,
        form.confirmPassword,
        navigate
      )
    );
  };

  return (
    <div className={`min-h-screen px-6 pt-4 pb-6 flex flex-col gap-6 `}>
      {/* Header */}
      <div>
        <h2
          className={`text-xl font-semibold ${
            darkMode ? "text-white" : "text-blue-900"
          }`}
        >
          Add New User
        </h2>
        <p
          className={`text-md font-semibold mt-1 ${
            darkMode ? "text-gray-300" : "text-gray-500"
          }`}
        >
          Create new user to this Portal
        </p>
        <div
          className={`h-[2px] w-full mt-2 ${
            darkMode ? "bg-gray-600" : "bg-blue-500"
          }`}
        />
      </div>

      {/* Main content */}
      <div className="flex flex-col md:flex-row gap-10 justify-center items-center">
        {/* Form */}
        <div
          className={`rounded-xl shadow-md p-8 w-full max-w-md ${
            darkMode ? "bg-gray-100" : "bg-gray-100"
          }`}
        >
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            {/* Name */}
            <div>
              <label className={`text-sm font-semibold text-gray-700`}>
                Name
              </label>
              <input
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Enter username"
                className={`mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring border-gray-300 bg-white text-gray-700 focus:ring-blue-300`}
                type="text"
              />
            </div>

            {/* Email */}
            <div>
              <label className={`text-sm font-semibold  text-gray-700`}>
                Email
              </label>
              <input
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter email"
                className={`mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring border-gray-300 bg-white text-gray-700 focus:ring-blue-300`}
                type="email"
              />
            </div>

            {/* Role */}
            <div>
              <label className={`text-sm font-semibold  text-gray-700`}>
                Role
              </label>
              <select
                name="role"
                value={form.role}
                onChange={handleChange}
                className={`mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring border-gray-300 bg-white text-gray-700 focus:ring-blue-300`}
              >
                <option value="" disabled>
                  Select role
                </option>
                <option value="Patient">Patient</option>
                <option value="Doctor">Doctor</option>
                <option value="Admin">Admin</option>
              </select>
            </div>

            {/* Password */}
            <div>
              <label className={`text-sm font-semibold  text-gray-700`}>
                Password
              </label>
              <input
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Enter password"
                className={`mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring border-gray-300 bg-white text-gray-700 focus:ring-blue-300`}
                type="password"
              />
            </div>

            {/* Confirm Password */}
            <div>
              <label className={`text-sm font-semibold  text-gray-700`}>
                Confirm Password
              </label>
              <input
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                placeholder="Confirm password"
                className={`mt-1 w-full px-4 py-2 border rounded-md focus:outline-none focus:ring border-gray-300 bg-white text-gray-700 focus:ring-blue-300`}
                type="password"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-4 pt-2">
              <button
                type="button"
                onClick={() => navigate("/dashboard/settings/user-management")}
                className={`border px-5 py-2 rounded-full text-sm font-medium transition-colors duration-300 ${
                  darkMode
                    ? "border-gray-400 text-gray-900 hover:bg-gray-700"
                    : "border-blue-900 text-blue-900 hover:bg-blue-50"
                }`}
              >
                Cancel
              </button>

              <button
                type="submit"
                className={`px-6 py-2 rounded-full text-sm font-medium shadow-md transition-colors duration-300 ${
                  darkMode
                    ? "bg-[#00254D] text-white hover:bg-[#003366]"
                    : "bg-[#00254D] text-white hover:bg-blue-800"
                }`}
              >
                Add
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddUserForm;
